import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { hrefFor } from '../../routers';
import { tc } from '../../lib/trackingContext';
import { CheckoutStep } from './useCheckoutStepTracking';

export const usePaymentInfoEnteredTracking = () => {
  const { pathname } = useLocation();
  const isCheckoutPage = pathname === hrefFor.CheckoutPage();

  const trackPaymentInfoEntered = useCallback(() => {
    isCheckoutPage
      ? tc.track('Payment Info Entered', {
          addToScopeOnce: {
            checkoutStep: CheckoutStep.PaymentMethod
          }
        })
      : tc.track('Payment Info Entered');
  }, [isCheckoutPage]);

  return { trackPaymentInfoEntered };
};
